<template>
  <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
    <DataGetter
      @dataAvailable="
        data => {
          walletInfo = data || {}
        }
      "
      :searchQuery="{ storeId }"
      contentId="walletInfo"
    />
    <DataGetter
      v-if="!storeStats"
      @dataAvailable="
        data => {
          stats = data?.metaData
        }
      "
      contentId="stats"
    />

    <DashboardFixStatBox
      :value1="`${stats?.balanceAvailable?.amount || walletInfo.balance || 0}`"
      :value2="`${stats?.balancePending?.amount || walletInfo.pendingBalance || 0}`"
      unit="FCFA"
      mainTitle="Soldes"
      title1="Solde marchand"
      title2="Solde D'opération (en attente)"
      bottomIndication="Solde actuel"
      class="md:col-span-2"
    />
    <DashboardPeriodicStatBox
      unit=""
      title="Clients uniques"
      :stats="customerStats"
    />
    <DashboardPeriodicStatBox
      unit="FCFA"
      title="Chiffre d'affaire"
      :stats="transactionStats"
    />
    <DashboardPeriodicStatBox
      unit=""
      title="Nombre de commandes"
      :stats="ordersStats"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DashboardPeriodicStatBox from './DashboardPeriodicStatBox.vue'
import DashboardFixStatBox from './DashboardFixStatBox.vue'
import DataGetter from '../utils/DataGetter.vue'

export default defineComponent({
  name: 'PlatformStats',
  components: { DashboardFixStatBox, DashboardPeriodicStatBox, DataGetter },
  props: {
    storeStats: {
      type: Object,
      default() {
        return null
      },
    },
    storeId: {
      type: String,
      default() {
        return null
      },
    },
  },
  data() {
    return {
      stats: this.storeStats || {},
      walletInfo: {},
      activeDuration: '1year',
      durations: [
        { name: '1 An', id: '1year' },
        { name: '6 Mois', id: '6months' },
        { name: '3 Mois', id: '3months' },
        { name: '1 Mois', id: '1month' },
      ],
    }
  },
  mounted() {},
  methods: {},
  watch: {
    storeStats: {
      deep: true,
      handler(newVal) {
        this.stats = newVal
      },
    },
  },
  computed: {
    customerStats() {
      const format = stat => ({
        value: stat.count || 0,
        title: stat.periodId || 0,
        detail: `${stat.count || 0} Clients`,
      })
      return {
        month: this.stats?.customerStatsMonth?.map(format) || Array(31).fill(0),

        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        week: [0, 0, 0, 0, 0, 0, 0],
        previousWeek: [0, 0, 0, 0, 0, 0, 0],
      }
    },
    transactionStats() {
      const format = stat => ({
        value: stat?.amount || 0,
        title: stat?.periodId || 0,
        detail: `${stat?.amount || 0} FCFA`,
      })
      return {
        month: this.stats?.paymentStatsMonth?.map(format) || Array(31).fill(0),
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        week: [0, 0, 0, 0, 0, 0, 0],
        previousWeek: [0, 0, 0, 0, 0, 0, 0],
      }
    },
    ordersStats() {
      const format = stat => ({
        value: stat?.count || 0,
        title: stat?.periodId || 0,
        detail: `${stat?.count || 0} Commandes`,
      })
      return {
        month: this.stats?.orderStatsMonth?.map(format) || Array(31).fill(0),
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        week: [0, 0, 0, 0, 0, 0, 0],
        previousWeek: [0, 0, 0, 0, 0, 0, 0],
      }
    },
  },
})
</script>
